import React, { Component } from 'react';
import { connect } from 'react-redux';
import { includes, find, clone } from 'lodash';
import * as util from 'lib/utility';
import { VirtualizedSelect } from 'containers';
import * as actions from 'state/modules/assign';
import styles from './PopupTrainingOpportunity.css';

let idMappingToValue = [];

const debug = _debug('app:PopupTrainingOpportunity');

class PopupTrainingOpportunity extends Component {
  static propTypes = {
    closePopup: React.PropTypes.func,
    wholeData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    inspectionsDataAll: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    updateInspectionsData: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    popupErrorLabel: React.PropTypes.func
    // updateInspectionsDisposition: React.PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      valueSelected: [],
      updateDropdownStyle: false
    };
  }

  componentWillMount() {
    const { strings } = this.props;
    const wholeData = this.props.wholeData;
    const trainingOpportunityArray = wholeData.cica_trainingopportunity;
    if (wholeData.cica_trainingopportunity) {
      const trainingOpportunityLabel =
        trainingOpportunityArray.map(value => util.getTrainingOpportunity(value, strings));
      this.setState({ valueSelected: trainingOpportunityLabel });
    } else {
      this.setState({ valueSelected: [] });
    }
  }

  trainingOpportunitylist = (list) => {
    idMappingToValue =
    list.map(item => (
      {
        value: item.value,
        label: item.label
      }));
    return list.map(item => (
      {
        value: item.label,
        label: item.label,
        clearableValue: false,
        disable: (this.state.valueSelected.indexOf('None') > -1 && item.label.indexOf('None') === -1) ||
          (this.state.valueSelected.indexOf('None') === -1 && item.label.indexOf('None') > -1 && this.state.valueSelected.length > 0)
      }), 'value');
  };

  updateFilter = (key, value) => {
    let valueSelected;
    const request = new Promise((resolve) => {
      valueSelected = value.length ? value.map(item => item.label) : [];
      if (includes(valueSelected, 'None')) {
        valueSelected = valueSelected.filter(obj => obj === 'None');
      }
      this.setState({ valueSelected });
      this.setState({ updateDropdownStyle: false });
      resolve(valueSelected);
    });
    return request;
  };

  updateNoContactData = () => {
    const inspectionData = this.props.wholeData;
    const dataId = inspectionData.id;
    let correctData = {};
    const submitData = {};
    if (this.state.valueSelected.length > 0) {
      this.props.inspectionsDataAll.forEach((data) => {
        if (data.id.indexOf(dataId) > -1) {
          correctData = clone(data);
          const selectedTrainingOpportunity = idMappingToValue.filter(mappingValue => (
            find(this.state.valueSelected, selectedValue => selectedValue === mappingValue.label)
          ));
          const secondTrainingOpportunityValue =
            selectedTrainingOpportunity.map(value => value.value);
          correctData.cica_trainingopportunity = secondTrainingOpportunityValue; // eslint-disable-line
          correctData.cica_couldnotcntowner = null;
          submitData.cica_couldnotcntowner = null;
          submitData.cica_isduplicate = false;
          correctData.cica_isduplicate = 0;
        }
      });
      debug(submitData);
      this.props.updateInspectionsData(correctData);
      this.props.closePopup();
      // this.props.updateInspectionsDisposition(correctData.id, submitData)
      // .catch((error) => {
      //   debug(error);
      // });
    } else {
      this.setState({ updateDropdownStyle: true });
    }
  }

  render() {
    const { strings } = this.props;
    const trainingOpportunityData = util.dropDownData(strings).trainingOpportunityData;
    return (
      <div className={styles.popupBody}>
        <div className={styles.pageDropDown}>
          <span className={styles.labelText}>
            {strings.trainingopportunityassociated}
          </span>
          <div className={styles.dropdown}>
            <VirtualizedSelect
              options={this.trainingOpportunitylist(trainingOpportunityData)}
              type={this.state.value}
              updateFilter={this.updateFilter}
              hintText="Select"
              filterValues={this.state.valueSelected}
              tetherToWindow={false}
              labelKey="label"
              valueKey="value"
              placeholder={strings.selectallthatapply}
              hiddenSearch
              placeholderStyle
              menuStyle={{ overflow: 'hidden', 'min-height': '250px' }}
              menuContainerStyle={{ 'min-height': '250px' }}
              maxHeight={250}
              className={this.state.updateDropdownStyle ? styles.pageDropDownError : undefined}
            />
            {this.state.updateDropdownStyle && this.props.popupErrorLabel}
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.updateNoContactData()}
            >{strings.save}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closePopup()}
            >{strings.cancel}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inspectionsDataAll: state.assign.inspectionsData
});

export default connect(mapStateToProps, actions)(PopupTrainingOpportunity);



// WEBPACK FOOTER //
// ./src/components/PopupTrainingOpportunity/PopupTrainingOpportunity.js